import { useRef } from "react";

import { Typography } from "@mui/material";

import {
	ImageViewer,
	TImageViewerRef,
} from "../../../common/FileViewer/ImageViewer";
import { PdfViewer, TPdfViewerRef } from "../../../common/FileViewer/PdfViewer";
import { useLearning } from "../hooks/useLearning";
import { LessonDocumentAudio } from "./LessonDocumentAudio";
import { LessonDocumentImage } from "./LessonDocumentImage";
import { LessonDocumentPdf } from "./LessonDocumentPdf";
import { LessonDocumentVideo } from "./LessonDocumentVideo";

export function LearningMaterial() {
	const { currentBooking } = useLearning();
	const imageViewerRef = useRef<TImageViewerRef>(null);
	const pdfViewerRef = useRef<TPdfViewerRef>(null);

	if (!currentBooking) {
		return null;
	}

	const lesson = currentBooking.lesson;
	const lessonDocuments = lesson.lessonDocuments;

	const videos = lessonDocuments.filter((lessonDocument) =>
		lessonDocument.contentType.startsWith("video/"),
	);

	const images = lessonDocuments.filter((lessonDocument) =>
		lessonDocument.contentType.startsWith("image/"),
	);

	const pdfs = lessonDocuments.filter(
		(lessonDocument) => lessonDocument.contentType === "application/pdf",
	);

	const audios = lessonDocuments.filter((lessonDocument) =>
		lessonDocument.contentType.startsWith("audio/"),
	);

	return (
		<div className="learning-material-container">
			{videos.length + images.length + pdfs.length === 0 && (
				<Typography className="normal-text item-separator-big">
					No Learning Material
				</Typography>
			)}
			{videos.length > 0 && (
				<div className="item-separator-big">
					<Typography className="normal-text bold">{`Videos (${videos.length})`}</Typography>
					<div className="item-separator-tiny video-list">
						{videos.map((video) => (
							<LessonDocumentVideo file={video} key={video.id} />
						))}
					</div>
				</div>
			)}
			{images.length > 0 && (
				<div className="item-separator-big">
					<Typography className="normal-text bold">{`Images (${images.length})`}</Typography>
					<div className="item-separator-tiny image-list">
						{images.map((image) => (
							<LessonDocumentImage
								file={image}
								key={image.id}
								imageViewerRef={imageViewerRef}
							/>
						))}
					</div>
				</div>
			)}
			{pdfs.length > 0 && (
				<div className="item-separator-big">
					<Typography className="normal-text bold">{`PDFs (${pdfs.length})`}</Typography>
					<div className="item-separator-tiny video-list">
						{pdfs.map((pdf) => (
							<LessonDocumentPdf
								file={pdf}
								key={pdf.id}
								pdfViewerRef={pdfViewerRef}
							/>
						))}
					</div>
				</div>
			)}
			{audios.length > 0 && (
				<div className="item-separator-big">
					<Typography className="normal-text bold">{`Audios (${audios.length})`}</Typography>
					<div className="item-separator-tiny video-list">
						{audios.map((audio) => (
							<LessonDocumentAudio file={audio} key={audio.id} />
						))}
					</div>
				</div>
			)}
			<ImageViewer ref={imageViewerRef} />
			<PdfViewer ref={pdfViewerRef} />
		</div>
	);
}
